import React from "react";
import { Parah } from "../ContentsStyles";

const TAC_9 = () => {
  return (
    <>
      <Parah>
        These Terms, and any rights and permissions granted in them, may not be
        transferred or assigned by you, but may be assigned by Talents Explore
        without restriction. If we do so, this will not affect your rights as a
        consumer. And, if you are not happy, you always have the right to
        terminate this contract and stop using the Platform at any time.
      </Parah>
      <Parah>
        In short: We have no plans to do so, but, if in the future we sell all
        or part of, or reorganise our business, another company may end up
        providing the Platform to you.
      </Parah>
      <Parah>
        We may reclaim your account name and might make it available to other
        users when you have not logged into your account for 6 months or if we
        reasonably believe that your account name violates our Terms and/or
        Community Guidelines (e.g. your account name violates third party
        trademark).
      </Parah>
      <Parah>
        In short: We may reclaim your account name in certain circumstances.
      </Parah>
      <Parah>
        Even if we or you delay in enforcing a provision of these Terms, either
        of us can still enforce it later. If we or you do not insist immediately
        that you or we do anything the other is required to do under these
        Terms, or if there is a delay in taking steps against the other in
        respect of breaching these Terms, that will not mean that we or you do
        not have to do those things and it will not prevent us or you from
        taking steps against the other at a later date.
      </Parah>
      <Parah>
        In short: Just because you or we do not rely on one of these Terms, this
        does not change the fact that we both agree that these Terms, as
        written, are the agreement between us.
      </Parah>
    </>
  );
};

export default TAC_9;
